import { useTranslation } from 'react-i18next';
import IPoolInfoProps from './interfaces/IPoolInfoProps';
import './pool-info.scss';

export default function PoolInfo({
    totalLoads,
    noRates,
}: Readonly<IPoolInfoProps>) {
    const { t } = useTranslation();

    return (
        <div className="round-info-container">
            <div>
                <span data-testid="available-counter">
                    {totalLoads - noRates}
                </span>
                <span>{t('Available')}</span>
            </div>
            <div>
                <span data-testid="no-rates-counter">{noRates}</span>
                <span>{t('NoRates')}</span>
            </div>
        </div>
    );
}
